import { FC, memo } from 'react';
import Color from './Color';

interface iColorsProps {
  colors: { name: string; color: string, example: string }[];
  value: string;
  onChange: (value: string) => void;
}

const Colors: FC<iColorsProps> = memo(({ colors, value, onChange }) => {
  return (
    <div className='colors-wrapper'>
      {colors.map((color) => (
        <Color {...color} active={value === color.color} onSelect={onChange} />
      ))}
    </div>
  );
});

export default Colors;
